import { useMutation } from "@tanstack/react-query";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";

export interface SendCodeViaSMSRequest {
  Id: number;
}

export const useSendCodeViaSMS = () => {
  const mutation = useMutation({
    mutationFn: (
      data: SendCodeViaSMSRequest,
    ): Promise<GeneralResponse> => {
      return Api<SendCodeViaSMSRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.ForgetPasswordSendCodeSMS, 
        body: data,
      });
    },
    onSuccess: (data) => {
      return data;
    }
  });

  return mutation;
};
